/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  var handleRemoveClick;
  var handleProceedClick;

  // Add custom code below this line
  const saleModal = document.querySelector("[data-modal='sale-modal']");

  if (saleModal) {
    handleRemoveClick = (e) => {
      const variantKey = e.currentTarget.getAttribute("data-key");
      console.log("Removing Key", variantKey);
      const removeBtn = document.querySelector(`[data-item-remove][data-id='${variantKey}']`);
      removeBtn.click();
      saleModal.classList.remove("show");
    };
  
  
    handleProceedClick = () => {
      saleModal.classList.remove("show");
    };
  }  

  if (saleModal) {
    console.log("Modal exists");
    const removeBtn = saleModal.querySelector(".sale-remove__btn");
    const proceedBtn = saleModal.querySelector(".sale-proceed__btn");
    const closeBtn = saleModal.querySelector(".closepopup");

    if (removeBtn) {
      removeBtn.addEventListener("click", handleRemoveClick);
    }

    if (proceedBtn) {
      proceedBtn.addEventListener("click", handleProceedClick);
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", handleProceedClick);
    }
  }

  
  // Collection Top Description Show/Hide
  const clickcollectionText = document.querySelector(".collection__description");
  if(clickcollectionText){
    clickcollectionText.addEventListener("click", (event) => {
      if(event.currentTarget == clickcollectionText ){
        if(clickcollectionText.innerText.length > 200){
          clickcollectionText.classList.toggle("show");
        }
        event.preventDefault();
      }
    });
  }
  window.document.onload = function(e){ 
    setTimeout(() => {
    let OOSProductForm = document.querySelector("#esc-oos-form");
    console.log("he",OOSProductForm);
    OOSProductForm = OOSProductForm.dataset.producttitle
    document.querySelector(".NBIS-Modal__ProductTitle").textContent = OOSProductForm;
    
    console.log(OOSProductForm.dataset.producttitle);
    }, 10000);  
  }

  const SelectSizeButton = document.body.querySelector("[select-data-add-to-cart]");
  if(SelectSizeButton){
    SelectSizeButton.addEventListener("click", (event) => {
      const SelectSizeCoverRed = document.querySelector(".select_size__cover [data-popout-toggle]");
      SelectSizeCoverRed.classList.add("red__color");
    });
  }




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

if(document.getElementById("countdown")){
  // Set the date we're counting down to
  var TimerDate = document.getElementById("countdown").getAttribute("data-timer");
  console.log(TimerDate)
  var countDownDate = new Date(TimerDate).getTime();
  
  // Update the count down every 1 second
  var x = setInterval(function() {
  
    // Get today's date and time
    var now = new Date().getTime();
      
    // Find the distance between now and the count down date
    var distance = countDownDate - now;
      
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
    // Output the result in an element with id="countdown"
  
    document.getElementById("countdown").innerHTML ="<div> <div>" + days + "</div><span>Days :</span></div><div> <div>" + hours + "</div><span>Hrs :</span></div> <div> <div>" +  minutes + "</div><span>Mins :</span></div><div> <div>" + seconds + "</div><span>Secs</span></div>";
      
    // If the count down is over, write some text 
    if (distance < 0) {
      clearInterval(x);
      document.getElementById("countdown").innerHTML = "EXPIRED";
     setTimeout(()=>{document.querySelector('.countdown_sticky').style.display = "none";},500);
    }else{
      document.querySelector(".countdown_sticky").classList.remove("hidden");
    }
  }, 1000);
}  


document.addEventListener('DOMContentLoaded', function () {
    var hh = document.querySelector('#SiteHeader').offsetHeight;
    var body = document.body;
    if (hh) {
        body.style.setProperty('--header-height', hh + 'px');
    }
});



// var refund_link = document.querySelectorAll('.refund_text_left ul a');
// if (refund_link) {
//   refund_link.forEach(function(link) {
//       link.addEventListener('click', function(event) {
//           event.preventDefault();
  
//           var targetId = this.getAttribute('href').substring(1);
//           var targetSection = document.getElementById(targetId);
  
//           if (targetSection) {
//               var headerHeight = document.querySelector('#SiteHeader').offsetHeight;
//               var offsetTop = targetSection.offsetTop - headerHeight;
  
//               window.scrollTo({
//                   top: offsetTop,
//                   behavior: 'smooth'
//               });
//           }
//       });
//   });
// }

window.closeDrawer = function(){

  const div = document.getElementById('collection_inner');
    const addBtn = document.getElementById('close-side-bar');
    const removeBtn = document.getElementById('open-side-bar');
    if(addBtn){
    addBtn.addEventListener('click',()=>{
        div.classList.add('close-components-sidebar');
    });
    }
    if(removeBtn){
    removeBtn.addEventListener('click',()=>{
        div.classList.remove('close-components-sidebar');
    });
    }
}
window.closeDrawer();

window.onload = function () {
  if(document.querySelector(".swiper-container")){
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
        
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      
    });
  }  
}

//custom popup
// document.addEventListener('DOMContentLoaded', ()=>{  
//   const secondButton = document.querySelector('.cartbtn');
//   const MainButton = document.querySelector('.cart__toggle');  
//   const closePopupButton = document.querySelector('.closepopup');
//   const closePopupBtns = document.querySelector('.btns');
//   const popupContainer = closePopupButton.closest('.custom-popup');

//     if(secondButton){
//      secondButton.addEventListener('click', ()=>{
//       MainButton.click();
//       //popupContainer.style.display = 'none';
//       popupContainer.classList.remove("show"); 
//     });
//   }
//     if(closePopupButton){
//      closePopupButton.addEventListener('click', () => {
//        //popupContainer.style.display = 'none';
//        popupContainer.classList.remove("show"); 
//      });
//    }
//     if(closePopupBtns){
//      closePopupBtns.addEventListener('click', () => {
//        //popupContainer.style.display = 'none';
//        popupContainer.classList.remove("show"); 
//      });
//    }
// });  


let lastScrollTop = 0;
const headers = document.querySelectorAll('.shopify-section-header');
const countdownTimer = document.querySelector('.countdown_sticky');

function updateCountdownStickyState() {
    if (!countdownTimer) {
        return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    countdownTimer.classList.toggle('countdown-is-fixed', scrollTop > 0);
}

window.addEventListener('scroll', function () {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    updateCountdownStickyState();

    headers.forEach(header => {
        if (scrollTop > lastScrollTop) {
            // Scroll DOWN
            header.classList.remove('header__past__active');
        } else {
            // Scroll UP
            header.classList.add('header__past__active');
        }
    });

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});

updateCountdownStickyState();


function updateCookieHeight() {
    const banner = document.querySelector(".shopify-pc__banner__dialog");
    if (!banner) return;

    const height = banner.getBoundingClientRect().height;

    document.documentElement.style.setProperty(
        "--cookie-height",
        height + "px"
    );
}

// Initial attempts
document.addEventListener("DOMContentLoaded", updateCookieHeight);
window.addEventListener("load", updateCookieHeight);
window.addEventListener("resize", updateCookieHeight);

// 🔥 MOST IMPORTANT — dynamic banner detection
const observer = new MutationObserver(updateCookieHeight);

observer.observe(document.body, {
    childList: true,
    subtree: true
});


document.addEventListener('DOMContentLoaded', () => {
    const timer = document.querySelector('.countdown_timer');

    if (!timer) {
        return;
    }

    function setTimerHeight() {
        if (timer.offsetParent === null) {
            return;
        }

        const height = timer.getBoundingClientRect().height;

        if (height > 0) {
            document.documentElement.style.setProperty(
                '--countdown-height',
                `${height}px`
            );
        }
    }

    window.addEventListener('load', setTimerHeight);

    window.addEventListener('resize', setTimerHeight);

    const observer = new ResizeObserver(setTimerHeight);
    observer.observe(timer);
});

(function () {
  const timers = new WeakMap();
  const countdownTargets = new WeakMap();

  function pluralize(value, label) {
    return `${value} ${label}${value === 1 ? '' : 's'}`;
  }

  function formatArrivalDate(date) {
    return date.toLocaleDateString('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'short'
    });
  }

  function parseCountdownDateTime(rawDateTime) {
    if (!rawDateTime) {
      return null;
    }

    const normalized = String(rawDateTime).trim();
    const match = normalized.match(
      /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/
    );

    if (!match) {
      return null;
    }

    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    const hour = Number(match[4]);
    const minute = Number(match[5]);
    const second = Number(match[6] || 0);

    const parsedDate = new Date(year, month, day, hour, minute, second);

    if (Number.isNaN(parsedDate.getTime())) {
      return null;
    }

    return parsedDate.getTime();
  }

  function hasCartItems(messageEl) {
    const cartRoot = messageEl.closest('[data-cart-page], [data-cart-drawer], .cart-drawer__body, .cart');
    const searchRoot = cartRoot || document;
    const emptyMessage = searchRoot.querySelector('[data-empty-message]');
    const cartQtyEl = searchRoot.querySelector('[data-cart-items-qty]');
    const cartQty = cartQtyEl ? Number.parseInt(cartQtyEl.textContent || '0', 10) : NaN;

    if (emptyMessage) {
      const isEmptyVisible = !emptyMessage.classList.contains('hidden') && !emptyMessage.hasAttribute('hidden');

      if (isEmptyVisible) {
        return false;
      }
    }

    if (!Number.isNaN(cartQty) && cartQty <= 0) {
      return false;
    }

    const itemsHolder = searchRoot.querySelector('[data-items-holder]');

    if (!itemsHolder) {
      return false;
    }

    return itemsHolder.querySelectorAll('[data-cart-item]').length > 0;
  }

  function updateDeliveryMessage(messageEl) {
    const deliveryDays = Number(messageEl.dataset.deliveryDays || 0);
    const cutoffEnabled = messageEl.dataset.cutoffEnabled === 'true';
    const countdownDateTime = messageEl.dataset.countdownDatetime || '';
    const arrivalPrefix = messageEl.dataset.arrivalPrefix || 'Arriving on';
    const countdownPrefix = messageEl.dataset.countdownPrefix || 'Order within';

    const arrivalTextEl = messageEl.querySelector('[data-cart-delivery-arrival-text]');
    const countdownTextEl = messageEl.querySelector('[data-cart-delivery-countdown-text]');
    const countdownWrapperEl = messageEl.querySelector('.cart-delivery-message__countdown');

    if (!arrivalTextEl || !countdownTextEl || !countdownWrapperEl) {
      return;
    }

    if (!hasCartItems(messageEl)) {
      messageEl.classList.add('is-hidden');
      messageEl.setAttribute('hidden', 'hidden');
      arrivalTextEl.textContent = '';
      countdownTextEl.textContent = '';
      return;
    }

    messageEl.classList.remove('is-hidden');
    messageEl.removeAttribute('hidden');

    const now = new Date();
    const arrivalDate = new Date(now);
    arrivalDate.setDate(arrivalDate.getDate() + deliveryDays);
    arrivalTextEl.textContent = `${arrivalPrefix} ${formatArrivalDate(arrivalDate)}`;

    if (!cutoffEnabled) {
      countdownWrapperEl.classList.add('is-hidden');
      countdownTextEl.textContent = '';
      return;
    }

    let countdownTarget = countdownTargets.get(messageEl);

    if (typeof countdownTarget === 'undefined') {
      countdownTarget = parseCountdownDateTime(countdownDateTime);
      countdownTargets.set(messageEl, countdownTarget);
    }

    if (!countdownTarget) {
      countdownWrapperEl.classList.add('is-hidden');
      countdownTextEl.textContent = '';
      return;
    }

    const distance = Math.max(countdownTarget - Date.now(), 0);
    const totalMinutes = Math.floor(distance / 60000);
    const totalHours = Math.floor(totalMinutes / 60);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    const minutes = totalMinutes % 60;

    countdownWrapperEl.classList.remove('is-hidden');

    if (days > 0) {
      countdownTextEl.textContent = `${countdownPrefix} ${pluralize(days, 'day')}, ${pluralize(hours, 'hour')} and ${pluralize(minutes, 'minute')}`;
      return;
    }

    if (hours > 0) {
      countdownTextEl.textContent = `${countdownPrefix} ${pluralize(hours, 'hour')} and ${pluralize(minutes, 'minute')}`;
      return;
    }

    countdownTextEl.textContent = `${countdownPrefix} ${pluralize(minutes, 'minute')}`;
  }

  function initCartDeliveryMessages() {
    const messages = document.querySelectorAll('[data-cart-delivery-message]');

    messages.forEach((messageEl) => {
      if (timers.has(messageEl)) {
        clearInterval(timers.get(messageEl));
      }

      countdownTargets.delete(messageEl);

      updateDeliveryMessage(messageEl);

      const intervalId = setInterval(() => {
        if (!document.body.contains(messageEl)) {
          clearInterval(intervalId);
          timers.delete(messageEl);
          return;
        }

        updateDeliveryMessage(messageEl);
      }, 1000);

      timers.set(messageEl, intervalId);
    });
  }

  document.addEventListener('DOMContentLoaded', initCartDeliveryMessages);
  document.addEventListener('theme:cart:loaded', initCartDeliveryMessages);
  document.addEventListener('theme:cart:open', initCartDeliveryMessages);
  document.addEventListener('theme:cart:update', () => {
    setTimeout(initCartDeliveryMessages, 100);
  });
})();


document.addEventListener("DOMContentLoaded", function () {

  function hideBlock() {
    document.querySelectorAll('.klaviyo-hide').forEach(el => {
      el.classList.add("show-welcome");
      // el.style.display = 'none';
    });
  }

  // Check if already submitted before
  if (localStorage.getItem('klaviyo_signed_up') === 'true') {
    hideBlock();
  }

  // Listen for Klaviyo form submit
  window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type === "submit") {
      console.log("Klaviyo form submitted");

      localStorage.setItem('klaviyo_signed_up', 'true');
      hideBlock();
    }
  });

});